import '../../../data/results.json';
import { debounce, isLocalhost } from '../../../js/modules/utilities';

const siteSearch = document.getElementById('site-search');
const loading = document.querySelector('.search-control__loader');
const results = document.querySelector('.results-search');
const resultsList = document.querySelectorAll('.results-search__list');
const locations = document.querySelector('.results-locations__wrapper');
const pages = document.querySelector('.results-search__additional--pages ul');
const aptFilters = document.querySelector('.apartment-filters');
const filters = document.querySelector('.apartment-filters__content');
const searchUrl = location.hostname == 'localhost' ? '/assets/data/results.json?' : '/maa-api/search/v2/get?';
const errorSearch = results && results.querySelector('.error-search');

const mobileTabs = document.querySelectorAll('.result-tabs li a');
const mobileCommunities = document.querySelector('.results-communities');
const mobileLocations = document.querySelector('.results-locations');

const resultMax = 2;
const resultsHeader = document.querySelector('.results-communities__header h4');
const resultsCommunities = document.querySelector('.results-communities .results-categories');
const bestMatch = document.querySelector('.result-item.bestmatch');
const toggleFilters = document.querySelector('.toggleFilters');

let query;
let loadFilters = false;
let slideActive = 0;
let slidePosition = 0;

let USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const handleShow = (e) => {
  e.preventDefault();
  e.currentTarget.parentElement.previousSibling.querySelectorAll('.results-categories__result.hide').forEach((item) => {
    item.classList.remove('hide');
  })
  e.currentTarget.remove();
}

const handleToggleFilters = (e) => {
  e.preventDefault();
  const span = e.currentTarget.querySelector('span');
  if (span) {
    span.classList.toggle('open');
  }
  const div = document.querySelector('.apartment-filters > div');
  if (div) {
    div.classList.toggle('hide');
  }
}

if (toggleFilters) {
  toggleFilters.addEventListener('click', handleToggleFilters);
}

const handleSearch = () => {
  if (siteSearch.value.length > 2) {
    loadFilters = false;
    loading.style.display = 'block';
    resultsCommunities.innerHTML = '';
    query = 'query=' + siteSearch.value;
    fetchResults(query);
  } else {
    results.style.visibility = 'hidden';
  }
}

if (siteSearch) siteSearch.addEventListener('keyup', debounce(() => handleSearch()));

const fetchResults = (query) => {
  fetch(searchUrl + query)
    .then(response => response.json())
    .then(response => {
      // just for local testing
      if (query === 'query=ooops' && isLocalhost()) {
        response.BestMatch = null;
        response.Data = [];
        response.Pages = [];
        response.Filters = [];
      }
      if (query === 'query=error' && isLocalhost()) {
        response = {
          "Message": "An error has occurred.",
          "ExceptionMessage": "Object reference not set to an instance of an object.",
          "ExceptionType": "System.NullReferenceException",
          "StackTrace": "   at MAA.Business.Cache.PropertyCacheManager.SetSearchSettings(SiteSearchSettings model) in C:\\src\\MAA.Business\\Cache\\PropertyCacheManager.cs:line 57\r\n   at MAA.Business.SiteSearch.SiteSearchService.DoSearch(SiteSearchRequest request) in C:\\src\\MAA.Business\\SiteSearch\\SiteSearchService.cs:line 170\r\n   at MAA.Web.Controllers.SearchApiController.Index(String query, String[] bedrooms, Nullable`1 maxPrice, String[] amenities, String[] locations, Int32 top) in C:\\src\\MAA.Web\\Controllers\\SearchApiController.cs:line 28\r\n   at lambda_method(Closure , Object , Object[] )\r\n   at System.Web.Http.Controllers.ReflectedHttpActionDescriptor.ActionExecutor.<>c__DisplayClass6_1.<GetExecutor>b__3(Object instance, Object[] methodParameters)\r\n   at System.Web.Http.Controllers.ReflectedHttpActionDescriptor.ExecuteAsync(HttpControllerContext controllerContext, IDictionary`2 arguments, CancellationToken cancellationToken)\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Controllers.ApiControllerActionInvoker.<InvokeActionAsyncCore>d__1.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Filters.ActionFilterAttribute.<CallOnActionExecutedAsync>d__6.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Web.Http.Filters.ActionFilterAttribute.<CallOnActionExecutedAsync>d__6.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Filters.ActionFilterAttribute.<ExecuteActionFilterAsyncCore>d__5.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Filters.ActionFilterAttribute.<CallOnActionExecutedAsync>d__6.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Web.Http.Filters.ActionFilterAttribute.<CallOnActionExecutedAsync>d__6.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Filters.ActionFilterAttribute.<ExecuteActionFilterAsyncCore>d__5.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Controllers.ActionFilterResult.<ExecuteAsync>d__5.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Filters.AuthorizationFilterAttribute.<ExecuteAuthorizationFilterAsyncCore>d__3.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Dispatcher.HttpControllerDispatcher.<SendAsync>d__15.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Web.Http.Dispatcher.HttpControllerDispatcher.<SendAsync>d__15.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.Cors.CorsMessageHandler.<SendAsync>d__2.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at Sitecore.Services.Infrastructure.Security.TokenDelegatingHandler.<SendAsync>d__6.MoveNext()\r\n--- End of stack trace from previous location where exception was thrown ---\r\n   at System.Runtime.ExceptionServices.ExceptionDispatchInfo.Throw()\r\n   at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task)\r\n   at System.Web.Http.HttpServer.<SendAsync>d__24.MoveNext()"
        };
      }
      loading.style.display = 'none';
      results.style.visibility = 'visible';

      if (
        (!(response.Properties) || response.Properties.Results.length === 0) &&
        (!(response.Pages) || response.Pages.length === 0)) {
        errorSearch && errorSearch.classList.remove('hide');
      } else {
        errorSearch && errorSearch.classList.add('hide');
      }

      if (response.hasOwnProperty('Locations') && response.Locations) {
        aptFilters.classList.add('active');
        resultsList.forEach((item) => {
          item.classList.add('active');
        });

        // LOAD LOCATIONS
        addLocations(response.Locations.Results);
      }

      // LOAD RESULT METRICS

      // LOAD CITIES
      if (response.hasOwnProperty('Properties') && response.Properties) {
        resultsHeader.innerHTML = `${response.Properties.TotalResults} communities and ${response.Pages.length} pages found for <span>"${siteSearch.value}"</span>`;

        resultsCommunities.innerHTML = '';
        response.Properties.Results.forEach((city) => {
          resultsCommunities.append(addCity(city));
        });
      }

      // LOAD BEST MATCH
      if (response.hasOwnProperty('BestMatch') && response.BestMatch) {
        addBestmatch(response.BestMatch);

        const nextImage = document.querySelector('button.next');
        const prevImage = document.querySelector('button.prev');
        nextImage.addEventListener('click', navCarousel);
        prevImage.addEventListener('click', navCarousel);
        document.querySelector('.results-search__list.bestmatch').classList.add('active');
      } else {
        document.querySelector('.results-search__list.bestmatch').classList.remove('active');
      }

      const showButton = document.querySelectorAll('.results-categories__show-button');

      if (showButton) {
        showButton.forEach((item) => {
          item.addEventListener('click', handleShow);
        })
      }

      // LOAD PAGES
      if (response.hasOwnProperty('Pages')) {
        addPages(response.Pages);
      }

      // LOAD FILTERS
      if (response.hasOwnProperty('Filters') && !loadFilters) {
        addFilters(response.Filters);

        const filterGroup = document.querySelectorAll('.apartment-filters__group');

        if (filterGroup) {
          filterGroup.forEach((item) => {
            item.addEventListener('click', (e) => {
              const openFilters = document.querySelectorAll('.apartment-filters__group.open');
              if (openFilters) {
                openFilters.forEach((item) => {
                  if (item != e.currentTarget) {
                    item.classList.remove('open');
                  }
                });
              }
              e.currentTarget.classList.toggle('open');
            })
          })
        }
      }
    })
    .catch(console.error);
}

const addCity = (city) => {
  const communities = document.createElement('UL');
  let maxReached = false;

  city.Items.forEach((item, index) => {
    maxReached = index > resultMax;
    const communityItem = addCommunity(item);
    communityItem.classList.toggle('hide', maxReached);
    communities.append(communityItem);
  })

  const container = document.createElement('DIV');
  container.setAttribute('role', 'group');
  container.classList.add("results-categories__container");
  container.innerHTML = `<div class="results-categories__header"><div class="results-categories__title serif"><div class="results-categories__wrapper"><div class="results-categories__icon"><i aria-hidden="true" class="icon-communities"></i></div><a href="${city.Url}">${city.City}, ${city.State}</a> <span>(${city.ItemsTotal})</span></div>${communities.outerHTML}`;

  container.innerHTML += maxReached ? '<div class="results-categories__show"><button class="results-categories__show-button regular"> Show all</button></div></div>' : '</div>';

  return container;
}

const addCommunity = (community) => {
  const amenitylist = document.createElement('UL');

  if (typeof community.AmenityIconList == 'string') {
    addAmenities(JSON.parse(community.AmenityIconList), amenitylist);
  }

  const communityItem = document.createElement('LI');
  communityItem.classList.add("results-categories__result");
  communityItem.innerHTML = `
    <div class="result-item">
      <div class="desktop-only">
        <div class="results-categories__result--image"><img src="${community.ImageUrl}"></div>
        <div class="results-categories__result--detail">
            <div class="detail-row">
              <a href="${community.Url}" id="${community.Id}" class="results-categories__result-item regular">${community.Title}</a>
              <div class="results-categories__result-start">Rent starting at ${community.Starting}</div>
            </div>
            <div class="detail-row">
              ${community.Description ? `
                <div class="results-categories__result-description regular">${community.Description}</div>
              ` : ''}
              ${community.Bedrooms ? `
                <div class="results-categories__result-beds">${community.Bedrooms}</div>
              ` : ''}
            </div>
            ${amenitylist.outerHTML ? `
              <div class="detail-row detail-list">
                ${amenitylist.outerHTML}
              </div>
            ` : ''}
        </div>
      </div>
      <div class="mobile-only">
        <div class="results-categories__result--title">
            <a href="${community.Url}" id="${community.Id}" class="results-categories__result-item regular">${community.Title}</a>
            <div class="results-categories__result-description regular">${community.Description}</div>
        </div>
        <div class="mobile-only__detail">
            <div class="results-categories__result--image"><img src="${community.ImageUrl}"></div>
            <div class="results-categories__result--detail">
              <div class="results-categories__result--title">
                  <a href="${community.Url}" id="${community.Id}" class="results-categories__result-item regular">${community.Title}</a>
                  ${community.Description ? `
                    <div class="results-categories__result-description regular">${community.Description}</div>
                  ` : ''}
              </div>
              <div class="detail-row">
                ${community.Starting ? `
                  <div class="results-categories__result-start">Rent starting at ${community.Starting}</div>
                ` : ''}
                ${community.Bedrooms ? `
                  <div class="results-categories__result-beds">${community.Bedrooms}</div>
                ` : ''}
              </div>
              <div class="detail-row detail-list">
                ${amenitylist.outerHTML}
              </div>
            </div>
        </div>
      </div>
    </div>`;
  return communityItem;
}

const addAmenities = (list, target) => {
  if (list) {
    list.forEach((item) => {
      const amenityItem = document.createElement('LI');
      amenityItem.innerHTML = `<div class="amenity-icon"><i aria-hidden="true" class="${item.Icon}"></i></div><span>${item.Name}</span>`;
      target.append(amenityItem);
    })
    return list;
  }
}

const addLocations = (list) => {
  document.querySelectorAll('.results-categories__result.community').forEach((el) => {
    el.remove();
  })

  Array.from(locations.getElementsByClassName("results-categories")).forEach((el) => {
    el.remove();
  })

  list.forEach((location) => {
    const locationGroup = document.createElement('DIV');
    locationGroup.classList.add('results-categories');
    const communityList = document.createElement('UL');
    let maxReached = false;

    location.Items.forEach((community, index) => {
      maxReached = index > resultMax;
      const communityItem = document.createElement('LI');
      communityItem.classList.add('results-categories__result', 'community');
      communityItem.classList.toggle('hide', maxReached);
      communityItem.innerHTML = `<a href="${community.Url}" id="${community.Id}" class="results-categories__result-item regular">${community.Title} (${community.Count})</a>`;
      communityList.append(communityItem);
    })

    let locationGroupHTML = `<div role="group" class="results-categories__container">
      <div class="results-categories__header">
        <div class="results-categories__title serif">
          <a href="${location.Url}">${location.City}, ${location.State}</a>
          ${communityList.outerHTML}`;

    locationGroupHTML += maxReached ? '<div class="results-categories__show"><button class="results-categories__show-button regular"> Show all</button></div></div></div></div>' : '</div></div></div></div>';

    locationGroup.innerHTML = locationGroupHTML;

    locations.append(locationGroup);
  })
}

const addBestmatch = (list) => {
  const imgCarousel = document.createElement('DIV');
  imgCarousel.classList.add('carousel', 'clip');

  const imgNav = document.createElement('DIV');
  imgNav.classList.add('carousel-info__nav-dots');

  let imgItem = '';
  let imgDot = '';
  let imgMobile = '';

  list.Images.forEach((img, index) => {
    imgItem += `<div class="carousel-item"><img src="${img.ImageUrl}"></div>`;
    imgDot += `<span data-index="${index}" class="${index == 0 ? 'active' : ''}"></span>`;

    if (index == 0) {
      imgMobile = `<img src="${img.ImageUrl}">`;
    }
  })

  imgCarousel.innerHTML = imgItem;
  imgNav.innerHTML = imgDot;

  const bestMatchAmenitylist = document.createElement('UL');

  if (typeof list.AmenityIconList == 'string') {
    addAmenities(JSON.parse(list.AmenityIconList), bestMatchAmenitylist);
  }

  const searchCarousel = `<div data-active="0" data-position="0" class="carousel clip">${imgCarousel.outerHTML}</div>
    <div class="carousel-info__nav">
      <button type="button" aria-label="Previous" class="prev"><i aria-hidden="true" class="icon-drop-arrow"></i></button>
      ${imgNav.outerHTML}
      <button type="button" aria-label="Next" class="next"><i aria-hidden="true" class="icon-drop-arrow"></i></button>
    </div>`;

  const bestMatchContent = `
    <div class="desktop-only">
      <div class="results-categories__result--image"><div class="search-carousel">${searchCarousel}</div></div>
      <div class="results-categories__result--detail">
        <div class="detail-row">
          <a href="${list.Url}" id="${list.Id}" class="results-categories__result-item regular">${list.Title}</a>
          <div class="results-categories__result-start">Rent starting at ${list.Starting}</div>
        </div>
        <div class="detail-row">
          ${list.Description ? `
            <div class="results-categories__result-description regular">${list.Description}</div>
          ` : ''}
          ${list.Bedrooms ? `
            <div class="results-categories__result-beds">${list.Bedrooms}</div>
          ` : ''}
        </div>
        ${bestMatchAmenitylist.outerHTML ? `
          <div class="detail-row detail-list">${bestMatchAmenitylist.outerHTML}</div>
        ` : ''}
      </div>
    </div>

    <div class="mobile-only">
      <div class="results-categories__result--title">
        <a href="${list.Url}" id="${list.Id}" class="results-categories__result-item regular">${list.Title}</a>
        <div class="results-categories__result-description regular">${list.Description}</div>
      </div>
      <div class="mobile-only__detail">
        <div class="results-categories__result--image"> ${imgMobile}</div>
        <div class="results-categories__result--detail">
          <div class="results-categories__result--title">
            <a href="${list.Url}" id="${list.Id}" class="results-categories__result-item regular">${list.Title}</a>
            ${list.Description ? `
              <div class="results-categories__result-description regular">${list.Description}</div>
            ` : ''}
          </div>
          <div class="detail-row">
            ${list.Starting ? `
              <div class="results-categories__result-start">Rent starting at ${list.Starting}</div>
            ` : ''}
            ${list.Bedrooms ? `
              <div class="results-categories__result-beds">${list.Bedrooms}</div>
            ` : ''}
          </div>
          ${bestMatchAmenitylist.outerHTML ? `
            <div class="detail-row detail-list">${bestMatchAmenitylist.outerHTML}</div>
          ` : ''}
        </div>
      </div>
    </div>`;

  bestMatch.innerHTML = bestMatchContent;
  document.querySelector('.results-search__list.bestmatch').classList.remove('hide');
}

const addPages = (list) => {
  const currentPageList = pages.querySelectorAll('li');
  if (currentPageList) {
    currentPageList.forEach((el) => {
      el.remove();
    });
  }

  list.forEach((item) => {
    const pageItem = document.createElement('LI');
    pageItem.innerHTML = `<a href="${item.Url}">${item.Title}</a></li>`;
    pages.append(pageItem);
  });

  const qwe = results.querySelector('.results-search__additional--pages');
  const pageTitle = qwe && qwe.querySelector('h3');
  if (list.length === 0) {
    pageTitle && pageTitle.classList.add('hide');
  } else {
    pageTitle && pageTitle.classList.remove('hide');
  }
}

const addFilters = (list) => {
  document.querySelectorAll('.apartment-filters__group').forEach((item) => {
    item.remove();
  })

  list.forEach((item) => {
    const filterGroup = document.createElement('DIV');
    filterGroup.setAttribute('role', 'group');
    filterGroup.classList.add('apartment-filters__group');

    const filterList = document.createElement('UL');
    filterList.setAttribute('id', item.FieldName);
    filterList.classList.add('apartment-filters__options-container');

    if (item.FieldName == 'maxPrice') {
      Object.keys(item.Values).forEach((key, index) => {
        filterList.append(addFilterItem('radio', item.FieldName, key, item.Values[key], index, 'Up to '));
      })
    } else {
      Object.keys(item.Values).forEach((key, index) => {
        filterList.append(addFilterItem('checkbox', item.FieldName, key, item.Values[key], index, ''));
      })
    }

    filterGroup.innerHTML = `<div>
        <button tabindex="0" class="apartment-filters__buttons">
          <p class="apartment-filters__title">${item.DisplayName}</p>
          <i aria-hidden="true" class="icon-drop-arrow"></i>
        </button>
        ${filterList.outerHTML}
      </div>`

    filters.append(filterGroup);

    document.querySelectorAll('.filter-input').forEach((el) => {
      el.addEventListener('change', handleFilter);
    })
  })

  loadFilters = true;
}

const handleFilter = (e) => {
  //console.log('change', e.currentTarget.checked);
  query = 'query=' + siteSearch.value;
  document.querySelectorAll('.filter-input').forEach((item) => {
    if (item.checked) {
      query += `&${item.getAttribute('name')}=${item.value}`;
    }
  })

  fetchResults(query);
}

const addFilterItem = (type, name, key, value, id, prefix) => {
  if (name == 'maxPrice') value = USDollar.format(value);
  const filterItem = document.createElement('LI');
  filterItem.classList.add("apartment-filters__option");
  filterItem.innerHTML = `<div class="input-wrapper"><input id="input-${name}-${id}" type="${type}" name="${name}" filter-title="${value}" role="checkbox" value="${key}" class="${type}-input filter-input"> <label for="input-${name}-${id}" class="${type}-label">${prefix}${value}</label></div>`;
  return filterItem;
}

const navCarousel = (e) => {
  e.stopPropagation();
  let carousel = e.currentTarget.parentElement.previousElementSibling;
  let slides = carousel.querySelectorAll('.carousel-item');
  let slideWidth = 100;
  let slideCount = slides.length;
  let dots = null;
  let nav = e.currentTarget.classList.contains('next') ? 'next' : 'prev';

  console.log(slides, carousel.children);

  if (nav === 'next' && Math.abs(slidePosition) < slideWidth * (slideCount - 1)) {
    slidePosition -= 100;
    slideActive++;
    dots = e.currentTarget.previousElementSibling.children;
  } else if (nav === 'prev' && slidePosition < 0) {
    slidePosition += 100;
    slideActive--;
    dots = e.currentTarget.nextElementSibling.children;
  }

  carousel.setAttribute('data-active', slideActive);
  carousel.setAttribute('data-position', slidePosition);

  carousel.style.transform = 'translateX(' + slidePosition + '%)';

  if (dots != null) {
    for (var i = 0; i < dots.length; i++) {
      if (i === slideActive) {
        dots[i].classList.add('active');
      } else {
        dots[i].classList.remove('active');
      }
    }
  }
}

document.addEventListener("openSearchWithValue", ((e) => {
  siteSearch.value = e.detail.value;
  siteSearch.focus();
  debounce(() => handleSearch());
}));

const switchTabs = (e) => {
  mobileTabs.forEach((item) => {
    item.classList.remove('active');
  });

  mobileCommunities.classList.remove('active');
  mobileLocations.classList.remove('active');

  const targetLabel = '.results-' + e.currentTarget.getAttribute('data-target');
  const target = document.querySelector(targetLabel);
  e.currentTarget.classList.add('active');
  target.classList.add('active');
}

mobileTabs.forEach((item) => {
  item.addEventListener('click', switchTabs);
})



// WEBPACK FOOTER //
// ./src/templates/components/nav-header/search.js